import React, {useState, useEffect} from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Tmdb from '../../lib/Tmdb';
import {Grid,Skeleton, Pagination, Stack, Typography} from '@mui/material';
import { styled } from "@mui/material/styles";
import MovieCard from '../../components/MovieRow/MovieCard';
import FeaturedItem from '../../components/FeaturedItem/FeaturedItem';
import { typography } from '@mui/system';


const SearchPage = ()=>{
    let { query, urlPageNumber } = useParams();
    const [returnedInfo, setReturnedInfo] = useState(null);
    const [currentPageNumber, setCurrentPageNumber] = useState(urlPageNumber)

    
    const changePage = (event)=>{
        setCurrentPageNumber(event.target.outerText)

      }
    useEffect(()=>{
        const loadAll = async () =>{
          if(query !==""){
            window.scrollTo(0, 100)
            let listOfItems = await Tmdb.searchInfo(query,currentPageNumber);
            setReturnedInfo(listOfItems);
          }
        }
        loadAll()
      },[query,currentPageNumber]);

      return(
        <>
          <Grid container sx={{paddingBottom:"7vh"}} container>
            <Grid container sx={{marginTop:"10vh"}} paddingBottom={4}>
              <Typography variant={'h5'} color="#999999" sx={{marginLeft:"3%"}}>
                Resultado de pesquisa:
              </Typography>
            </Grid>
             {returnedInfo !== null ?
              returnedInfo.results.length > 0 ?
                <>
                    {returnedInfo.results.map((item,key)=>(
                        <Grid item xs={6} md={3} lg={2} key={key}><MovieCard item={item}/></Grid>
                    ))}
   
                   <Grid container justifyContent="center" paddingBottom={2} paddingTop={4}>
                   <Stack spacing={2}>
                    <Pagination color='error' onClick={event => changePage(event)} count={returnedInfo.total_pages} hidePrevButton hideNextButton/>
                    </Stack>
                   </Grid>
                </>
                :
                <Grid sx={{marginLeft:"3%"}}>
                <Typography variant={'p'} color="#999999">
                  Infelizmente não encontramos nenhum título correspondente à: {query}
                </Typography>
              </Grid>
                
              :
              <></>
              }
               
         </Grid>
        </>
     );
}


export default SearchPage;